import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import Message, {
  MessageTypes
} from '../../../components/common/message/Message'

export const RelativeCampaignActionWarning: FC<{
  day: number | null
  respectBusinessHours?: boolean
}> = ({ day, respectBusinessHours }) => {
  if (day !== 0 || respectBusinessHours) {
    return null
  }
  return (
    <section>
      <Message type={MessageTypes.WARNING}>
        <Trans>
          <p>
            <strong>Day 0</strong> is the <strong>same day</strong> the user
            joins the campaign.
          </p>
          <p>
            We aim to perform the this action on the same day as a user joins
            the campaign. However, please note that the exact time may vary. If
            the user join this campaign after the planned action time, we will
            schedule this action within the next 5 minutes.
          </p>
        </Trans>
      </Message>
    </section>
  )
}
